import { createRouter, createWebHistory } from 'vue-router'
import { setupRouterGuards } from './guards'

// Combined route table during the transition: new routes + the legacy routes
// served unchanged from src_old. Keep exactly ONE catch-all, last.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  // Legacy behavior kept: every navigation scrolls to top (ada-app-ui has no
  // scrollBehavior, but this portal is mobile-heavy with long debt lists).
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    // Dev-only sandbox — registered only in dev builds so it never enters the
    // production bundle.
    ...(import.meta.env.DEV
      ? [
          {
            name: 'Dev',
            path: '/dev',
            meta: { public: true },
            component: () => import('@/views/DevPlayground/DevPlayground.vue'),
          },
        ]
      : []),

    // ADA-4430: Home/Översikt migrated to the new src/ stack (keeps the route name 'Home' —
    // deep-links and guards reference it). Remaining routes stay legacy until their own view-tasks.
    { name: 'Home', path: '/', component: () => import('@/views/Home/Home.vue') },
    // ADA-4497: Authenticate/login migrated (route name + meta.public unchanged — guards,
    // useAuthEffects and useLegacyBootstrap reference the name).
    {
      name: 'Authenticate',
      path: '/authenticate',
      meta: { public: true },
      component: () => import('@/views/Authenticate/Authenticate.vue'),
    },
    { name: 'Profile', path: '/profile', component: () => import('@old/views/Profile.vue') },
    { name: 'DebtSummary', path: '/summary', component: () => import('@/views/Summary/Summary.vue') },
    // ADA-4435: Support + ticket chat migrated to the new src/ stack. Route names stay —
    // deep links and in-app navigation ({ name: 'Support' } in FDebtActionMenu) reference them.
    { name: 'Support', path: '/support', component: () => import('@/views/Support/Support.vue') },
    {
      name: 'TicketView',
      path: '/support/:ticket_id',
      props: true,
      component: () => import('@/views/Ticket/Ticket.vue'),
    },
    { name: 'AboutSite', path: '/om-webbplatsen', component: () => import('@old/views/AboutSite.vue') },
    { name: 'OCR', path: '/ocr/:ocr', redirect: '/' },
    {
      name: 'Overpayments',
      path: '/overinbetalningar',
      component: () => import('@/views/Overpayments/Overpayments.vue'),
    },

    // Greedy single-segment param — matches any top-level path not claimed by a
    // static route (legacy debt deep-links)
    { name: 'Debt', path: '/:debt_id', props: true, component: () => import('@/views/Debt/Debt.vue') },

    { name: 'PageNotFound', path: '/:pathMatch(.*)*', redirect: '/' },
  ],
})

setupRouterGuards(router)

export default router
